import { Company, Customer } from './customer.model';

export enum OnboardingStatus {
  none = -1,
  plans = 0,
  account = 1,
  port = 2,
  esign = 3,
  payment = 4,
  invoice = 5,
  finished = 6
}

export interface User {
  _id?: string;
  externalId?: string;
  email?: string;
  first?: string;
  last?: string;
  customer?: Customer;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  zip?: string;
  mobile?: string;
  phone?: string;
  roles?: string[];
  onboardingStatus?: OnboardingStatus;
  selectedPlanCode?: string;
  // Receives the AI call-summary email; toggled by a super admin on the Users page.
  aiSummaryEnabled?: boolean;
  // Where those summaries go. Empty means "use the account email above".
  aiSummaryEmail?: string;
  aiSummaryCc?: string;
  // Whether they actually receive the emails (undefined counts as on) — lets someone have the
  // AI Summary page without the inbox traffic.
  aiSummaryEmailEnabled?: boolean;
  // Missed-call alerts, independent of AI Summary.
  missedCallEmailEnabled?: boolean;
  missedCallEmail?: string;
  missedCallCc?: string;
}
